/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { AuthProvider } from '@sparkai/auth'
import { MonitoringErrorBoundary } from '@sparkai/monitoring'
import { defineHost, queryClient } from '@sparkai/utils'
import { QueryClientProvider } from '@tanstack/react-query'
import { createBrowserRouter, RouterProvider } from 'react-router-dom-v5-compat'

import { AppRoutes } from './AppRoutes'
import { env } from './env'

function GlobalProviders({ children }: { children: React.ReactNode }) {
  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider
        audience={env.VITE_AUTH0_AUDIENCE!}
        clientId={env.VITE_AUTH0_CLIENT_ID!}
        domain={env.VITE_AUTH0_DOMAIN!}
        redirectUri={defineHost(env.VITE_AUTH0_REDIRECT_URI!, '/redirector/')}
        mfaDomain={env.VITE_AUTH0_MFA_DOMAIN!}
        isOnRedirectorApp
      >
        {children}
      </AuthProvider>
    </QueryClientProvider>
  )
}

const router = createBrowserRouter([
  {
    path: '*',
    element: (
      <MonitoringErrorBoundary>
        <GlobalProviders>
          <AppRoutes />
        </GlobalProviders>
      </MonitoringErrorBoundary>
    ),
  },
])

function App() {
  return <RouterProvider router={router} />
}

export default App
